﻿$(function () {
    DismissAlerts();
});

function DismissAlerts() {
    const timeOutDelay = 10 * 1000;

    setTimeout(function () {
        $(".alert-dismissable").not(".alert-danger").each(function () {
            $(this).alert("close");
        });
    }, timeOutDelay);

    setTimeout(function () {
        $(".alert.auto-dismiss").each(function () {
            $(this).alert("close");
        });
    }, timeOutDelay);
}